import {SwitchButton} from "@ui/buttons/SwitchButton";
import {BorderArticle} from "@ui/general/BorderArticle";
import {H2} from "@ui/titles/H2";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const ScreenLayout = (props) => {
  const {
    title,
    switchView,
    controlsList,
    children,
    switchList,
    switchValue,
    switchOnChange,
    switchOnClickTab,
    switchWidth,
  } = props;
  const {sessions} = useSelector((state) => state.common.viewTabs);

  const handleChange =
    switchOnChange ||
    ((value) => {
      const item = switchList?.find((tab) => tab.value === value);
      if (item) switchOnClickTab(item);
    });

  return (
    <div className={styles.screenWrapper}>
      <BorderArticle>
        <div className={"container-small"}>
          <div className={styles.screen}>
            <div className={styles.head}>
              <H2>{title}</H2>

              {controlsList && (
                <ul className={styles.headControls}>
                  {controlsList.map(
                    (item) => item && <li key={item?.id}>{item?.button}</li>,
                  )}
                </ul>
              )}

              {switchView && (
                <SwitchButton
                  value={switchValue ?? sessions}
                  onChange={handleChange}
                  switchList={switchList ?? []}
                  onClickTab={switchOnClickTab}
                  width={switchWidth}
                />
              )}
            </div>

            {children}
          </div>
        </div>
      </BorderArticle>
    </div>
  );
};
